gsap.registerPlugin(ScrollTrigger);
window.addEventListener('DOMContentLoaded', (event) => {
    const sections = gsap.utils.toArray('.page--about--timeline-item')
    sections.forEach((section, index) => {
        gsap.to(document.querySelectorAll('.page--about--timeline-images__wrapper')[index], 1, {
            scrollTrigger: {
                trigger: section,
                scrub: 0,
                //markers: true,
                start: `top +=${document.querySelector(".page--about--timeline-line").offsetTop - 210}`,
                end: `top +=${document.querySelector(".page--about--timeline-line").offsetTop}`
            },
            display: 'block'
        })
        gsap.to(section?.querySelector('.component--about--card__title'), {
            scrollTrigger: {
                trigger: section,
                scrub: 0,
                //markers: true,
                start: `top +=${document.querySelector(".page--about--timeline-line").offsetTop - 210}`,
                end: `top +=${document.querySelector(".page--about--timeline-line").offsetTop}`
            },
            color: "#00b1b0",
            ease: "none"
        })
        gsap.to(section?.querySelector('.page--about--timeline-point'), {
            scrollTrigger: {
                trigger: section,
                scrub: 0,
                start: `top +=${document.querySelector(".page--about--timeline-line").offsetTop - 210}`,
                end: `top +=${document.querySelector(".page--about--timeline-line").offsetTop}`
            },
            backgroundColor: "#00b1b0",
            ease: "none"
        })
    });
    ScrollTrigger.matchMedia({
        // desktop
        "(min-width: 800px)": function () {
            document.querySelector(".page--about--timeline-images__container").style.top = `${document.querySelector(".page--about--timeline-line").offsetTop -  220}px`
            document.querySelector(".page--about--timeline-line").style.height = `${(document.querySelector(".page--about--timeline-line").offsetHeight) - sections[sections.length - 1].clientHeight}px`
            gsap.to('.page--about--timeline-inner-line', 1, {
                scrollTrigger: {
                    trigger: '.page--about--timeline',
                    scrub: 0, 
                    //markers: true,
                    start:`top +=${document.querySelector(".page--about--timeline-line").offsetTop - 210}`,
                    end: () => `+=${document.querySelector(".page--about--timeline-line").offsetHeight}`
                },
                height: document.querySelector(".page--about--timeline-line").offsetHeight,
                ease: "none"
            })
        },
        // mobile
        "(max-width: 799px)": function () {
            document.querySelector(".page--about--timeline-images__container").style.top = `${document.querySelector(".page--about--timeline-line").offsetTop - document.querySelector(".page--about--timeline-images__image").clientHeight}px`
            document.querySelector(".page--about--timeline-line").style.height = `${document.querySelector(".page--about--timeline-line").offsetHeight - sections[sections.length - 1].clientHeight}px`
            gsap.to('.page--about--timeline-inner-line', 1, {
                scrollTrigger: {
                    trigger: '.page--about--timeline',
                    scrub: 0, 
                    //markers: true,
                    start: `top +=${document.querySelector(".page--about--timeline-line").offsetTop + 24}`,
                    end: () => `+=${document.querySelector(".page--about--timeline-line").clientHeight}`
                },
                height: document.querySelector(".page--about--timeline-line").clientHeight,
                ease: "none",
            })
        }
      });
});